<div class="flex-container h-100" [style.gap]="gutter">
  <div class="animation">
    <ng-lottie [options]="optionsError"></ng-lottie>
    <div class="title">{{ title | translate }}</div>
    <span class="loader-text">{{ text | translate }}</span>
    <div class="k-d-flex k-flex-row k-gap-4 k-justify-content-center k-align-items-center">
    <div *ngIf="hasCancelButton" class="button-container">
      <button (click)="handleCancel()" [disabled]="isRetrying" themeColor="base" kendoButton>
        {{ 'SHARED.ERROR.ACTIONS.CANCEL' | translate }}
      </button>
    </div>
    <button
      (click)="handleRetry()"
      [disabled]="isRetrying"
      [style.gap]="btnGutter"
      class="k-d-flex k-flex-row k-gap-2 k-align-items-center k-justify-content-center k-mt-4"
      themeColor="primary"
      kendoButton>
      <span *ngIf="!isRetrying">{{ 'SHARED.ERROR.ACTIONS.RETRY' | translate }}</span>
      <span *ngIf="isRetrying" class="k-mr-2">{{ 'SHARED.ERROR.LABELS.RETRYING' | translate }}</span>
      <kendo-loader
        *ngIf="isRetrying" type="pulsing" themeColor="light"
        size="small">
      </kendo-loader>
    </button>
  </div>
  </div>
</div>
